<template>
  <div class="box">
    <div
      v-for="(t,index) in fields"
      :key="index"
      class="info-wrapper"
    >
      <div class="title">
        {{ t.name }}
      </div>
      <div v-if="recordParams[t.prop]===undefined || recordParams[t.prop]==='' || recordParams[t.prop]===null">
        --
      </div>
      <div v-if="recordParams[t.prop] &&recordParams[t.prop].length<=(t.tooltipLength || 20)" class="desc cursor1">
        {{ recordParams[t.prop]||"--" }}
      </div>
      <el-tooltip
        v-if="recordParams[t.prop] &&recordParams[t.prop].length>(t.tooltipLength || 20)"
        class="item"
        effect="dark"
        :content="recordParams[t.prop]"
        placement="top-start"
      >
        <div class="desc cursor2">
          {{ recordParams[t.prop].slice(0,t.tooltipLength || 20) }}...
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordParams: {
      type: Object,
      default: () => { },
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang='scss' scoped>
.box{
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #F7F8FA;
  padding:16px 0;
}
.info-wrapper{
  display: flex;
  justify-content: space-between;
  line-height: 26px;
}
.title{
  color: #646566 !important;
  font-weight: 400!important;
}
.cursor2{
   cursor: pointer;
}
.desc{
  color: #323233!important;
  font-weight: 400!important;
  // max-width: 212px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.line {
  border-top: 1px solid gray;
  margin: 12px 0;
  padding-top: 20px;
  font-weight: bold;
  font-size: 16px;
}
.basic {
  padding-bottom: 20px;
  font-weight: bold;
  font-size: 16px;
}
</style>
